<template>
  <div
    v-if="channel && $login.can('channels.view')"
    class="channels-list"
  >
    <div
      class="my-4"
      v-if="channel"
    >
      <vue-good-table
        :rows="channel.analysts"
        styleClass="vgt-table"
        :columns="columns"
        @on-row-click="({row}) => $router.push({
          name: 'analysts.view',
          hash: '#details',
          params: {analystId: row.id}
        })"
      >
        <template slot="table-row" slot-scope="props">
          <dropdown
            v-if="props.column.field == 'menu'"
            placement="bottom"
            width="96"
            trigger="click"
            popper-class="table-popover"
          >
            <template slot="trigger">
              <icon icon="more-vertical" />
            </template>
            <dropdown-option>
              <a
                v-if="$login.can('analysts.delete')"
                href="javascript:;"
                class="text-gray-600"
                style="text-decoration: none;margin: 2px;"
                @click="confirmDelete(channel.analysts[scope.$index])"
              >
                <icon icon="tag-remove" /> Delete
              </a>
            </dropdown-option>
          </dropdown>
        </template>
      </vue-good-table>
    </div>
    <confirm
      v-if="deletee"
      :name="deletee.name"
      @confirmed="deleteAnalyst"
    />
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';

import Confirm from '@/components/Confirm'
import {successNotification} from '@/notifications'
import Dropdown from '@/components/Dropdown/Dropdown'
import DropdownOption from '@/components/Dropdown/DropdownOption'

export default {
  components: {
    VueGoodTable,
    Confirm,
    Dropdown,
    DropdownOption,
  },

  props: {
    channel: {
      required: true,
      type: Object,
    },
  },

  data () {
    return {
      deletee: null,
      columns: [
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Last Updated',
          field: 'updated_at',
        },
        {
          label: '',
          field: 'menu'
        }
      ],
    }
  },

  methods: {
    confirmDelete (analyst) {
      this.deletee = analyst
      this.$nextTick(() => this.$modal.show('confirm-delete'))
    },

    deleteAnalyst () {
      this.$http.delete('/analysts/' + this.deletee.id).then(() => {
        this.channel.analysts.splice(this.channel.analysts.indexOf(this.deletee), 1)
        this.$notify(successNotification(`Deleted ${this.deletee.name}`))
      })
    },

  },

}
</script>
